<!-- instagram -->
<a
    class="inline-flex justify-center items-center gap-x-2 border border-transparent rounded-full focus:outline-none size-10 font-semibold text-gray-500 text-sm hover:scale-105 transition-transform disabled:pointer-events-none"
    data-umami-event="instagram-icon-click"
    href="https://www.instagram.com/hof.zehentmoar"
    target="_blank"
    aria-label="Instagram"
>
    @if (withFill()) {
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 566.93 566.93"
            width="32"
            height="32"
        >
            <defs>
                <style>
                    .cls-2 {
                        fill: #fff;
                    }
                    .cls-3 {
                        fill: #d08a44;
                    }
                </style>
            </defs>
            <path
                d="M95.18 566.93h391.16c44.51 0 80.59-36.08 80.59-80.59V95.18c0 260.54-211.21 471.75-471.75 471.75"
                style="fill: #b27939"
            />
            <path
                class="cls-3"
                d="M566.3 70.7c.41 8.11.63 16.27.63 24.48V80.59c0-3.35-.23-6.64-.63-9.89"
            />
            <path
                class="cls-3"
                d="M486.34 0H80.59C36.08 0 0 36.08 0 80.59v405.75c0 41.16 30.86 75.08 70.7 79.96 8.11.41 16.27.63 24.48.63 260.54 0 471.75-211.21 471.75-471.75q0-12.315-.63-24.48C561.43 30.86 527.5 0 486.34 0"
            />
            <path
                class="cls-2"
                d="M372.58 175.26c-10.9 0-19.73 8.84-19.73 19.73s8.84 19.73 19.73 19.73 19.73-8.84 19.73-19.73-8.84-19.73-19.73-19.73m-87.73 25.31c-45.71 0-82.9 37.19-82.9 82.9s37.19 82.9 82.9 82.9 82.9-37.19 82.9-82.9-37.19-82.9-82.9-82.9m0 135.99c-29.28 0-53.1-23.82-53.1-53.1s23.82-53.1 53.1-53.1 53.1 23.82 53.1 53.1-23.82 53.1-53.1 53.1"
            />
            <path
                class="cls-2"
                d="M350.66 451.77H216.27c-55.75 0-101.11-45.36-101.11-101.11v-134.4c0-55.75 45.36-101.11 101.11-101.11h134.39c55.75 0 101.11 45.35 101.11 101.11v134.4c0 55.75-45.36 101.11-101.11 101.11M216.27 146.83c-38.29 0-69.44 31.15-69.44 69.44v134.4c0 38.29 31.15 69.44 69.44 69.44h134.39c38.29 0 69.44-31.15 69.44-69.44v-134.4c0-38.29-31.15-69.44-69.44-69.44z"
            />
        </svg>
    } @else {
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            class="fill-inherit"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.45455 0C4.24181 0 0 4.24181 0 9.45455V22.5455C0 27.7582 4.24181 32 9.45455 32H22.5455C27.7582 32 32 27.7582 32 22.5455V9.45455C32 4.24181 27.7582 0 22.5455 0H9.45455ZM9.45455 1.45455H22.5455C26.972 1.45455 30.5455 5.02801 30.5455 9.45455V22.5455C30.5455 26.972 26.972 30.5455 22.5455 30.5455H9.45455C5.02801 30.5455 1.45455 26.972 1.45455 22.5455V9.45455C1.45455 5.02801 5.02801 1.45455 9.45455 1.45455ZM24.7273 5.81818C24.3415 5.81818 23.9715 5.97143 23.6988 6.24421C23.426 6.51699 23.2727 6.88696 23.2727 7.27273C23.2727 7.6585 23.426 8.02847 23.6988 8.30125C23.9715 8.57403 24.3415 8.72727 24.7273 8.72727C25.113 8.72727 25.483 8.57403 25.7558 8.30125C26.0286 8.02847 26.1818 7.6585 26.1818 7.27273C26.1818 6.88696 26.0286 6.51699 25.7558 6.24421C25.483 5.97143 25.113 5.81818 24.7273 5.81818ZM16 8C11.5903 8 8 11.5903 8 16C8 20.4097 11.5903 24 16 24C20.4097 24 24 20.4097 24 16C24 11.5903 20.4097 8 16 8ZM16 9.45455C19.6236 9.45455 22.5455 12.3764 22.5455 16C22.5455 19.6236 19.6236 22.5455 16 22.5455C12.3764 22.5455 9.45455 19.6236 9.45455 16C9.45455 12.3764 12.3764 9.45455 16 9.45455Z"
                class="fill-inherit"
            />
        </svg>
    }
</a>
<!-- facebook -->
<a
    class="inline-flex justify-center items-center gap-x-2 ml-2 border border-transparent rounded-full focus:outline-none size-10 font-semibold text-gray-500 text-sm hover:scale-105 transition-transform disabled:pointer-events-none"
    data-umami-event="facebook-icon-click"
    href="https://www.facebook.com/people/Zehentmoar-Hof/61570418783964/"
    target="_blank"
    aria-label="Facebook"
>
    @if (withFill()) {
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 566.93 566.93"
            height="32"
            width="32"
        >
            <defs>
                <style>
                    .cls-3 {
                        fill: #d08a44;
                    }
                </style>
            </defs>
            <path
                d="M95.18 566.93h391.16c44.51 0 80.59-36.08 80.59-80.59V95.18c0 260.54-211.21 471.75-471.75 471.75"
                style="fill: #b27939"
            />
            <path
                class="cls-3"
                d="M566.3 70.7c.41 8.11.63 16.27.63 24.48V80.59c0-3.35-.23-6.64-.63-9.89"
            />
            <path
                class="cls-3"
                d="M486.34 0H80.59C36.08 0 0 36.08 0 80.59v405.75c0 41.16 30.86 75.08 70.7 79.96 8.11.41 16.27.63 24.48.63 260.54 0 471.75-211.21 471.75-471.75q0-12.315-.63-24.48C561.43 30.86 527.5 0 486.34 0"
            />
            <path
                d="M319.23 489.45V309.21h60.1l11.43-74.56h-71.53v-48.38c0-20.4 9.99-40.28 42.03-40.28h32.52V82.52s-29.52-5.04-57.74-5.04c-58.92 0-97.42 35.71-97.42 100.35v56.82h-65.49v74.56h65.49v180.24h80.6Z"
                style="fill: #fff"
            />
        </svg>
    } @else {
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            class="fill-inherit"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M16 0C7.17168 0 0 7.17168 0 16C0 24.8283 7.17168 32 16 32C24.8283 32 32 24.8283 32 16C32 7.17168 24.8283 0 16 0ZM16 1.3913C24.0764 1.3913 30.6087 7.9236 30.6087 16C30.6087 24.0764 24.0764 30.6087 16 30.6087C7.9236 30.6087 1.3913 24.0764 1.3913 16C1.3913 7.9236 7.9236 1.3913 16 1.3913ZM17.0992 5.56522C15.2544 5.56522 13.8554 6.1685 12.9932 7.23505C12.1311 8.30161 11.8261 9.72595 11.8261 11.288V12.5217H10.4348C10.2503 12.5218 10.0734 12.5951 9.9429 12.7255C9.81245 12.856 9.73915 13.0329 9.73913 13.2174V16.6957C9.73915 16.8801 9.81245 17.0571 9.9429 17.1875C10.0734 17.318 10.2503 17.3913 10.4348 17.3913H11.8261V25.7391C11.8261 25.9236 11.8994 26.1006 12.0299 26.231C12.1603 26.3615 12.3372 26.4348 12.5217 26.4348H16.6957C16.8801 26.4348 17.0571 26.3615 17.1875 26.231C17.318 26.1006 17.3913 25.9236 17.3913 25.7391V17.3913H20.1739C20.3348 17.3912 20.4907 17.3354 20.615 17.2334C20.7394 17.1313 20.8245 16.9893 20.856 16.8315L21.5516 13.3533C21.5717 13.2524 21.5692 13.1483 21.5442 13.0485C21.5192 12.9488 21.4724 12.8558 21.4072 12.7762C21.342 12.6967 21.2599 12.6326 21.167 12.5886C21.074 12.5446 20.9724 12.5218 20.8696 12.5217H17.3913V10.9959C17.3913 10.6585 17.4131 10.6613 17.5109 10.5978C17.6086 10.5344 17.9619 10.4348 18.5815 10.4348H20.8696C21.0541 10.4348 21.231 10.3615 21.3614 10.231C21.4919 10.1006 21.5652 9.92362 21.5652 9.73913V6.95652C21.5651 6.81305 21.5207 6.67311 21.438 6.55588C21.3553 6.43864 21.2384 6.34984 21.1033 6.30163C21.1033 6.30163 19.1001 5.56522 17.0992 5.56522ZM17.0992 6.95652C18.4157 6.95652 19.6365 7.31162 20.1739 7.47962V9.04348H18.5815C17.853 9.04348 17.2619 9.10232 16.7541 9.43207C16.2463 9.76181 16 10.3935 16 10.9959V13.2174C16 13.4019 16.0733 13.5788 16.2038 13.7093C16.3342 13.8397 16.5112 13.913 16.6957 13.913H20.0204L19.6033 16H16.6957C16.5112 16 16.3342 16.0733 16.2038 16.2038C16.0733 16.3342 16 16.5112 16 16.6957V25.0435H13.2174V16.6957C13.2174 16.5112 13.1441 16.3342 13.0136 16.2038C12.8832 16.0733 12.7062 16 12.5217 16H11.1304V13.913H12.5217C12.7062 13.913 12.8832 13.8397 13.0136 13.7093C13.1441 13.5788 13.2174 13.4019 13.2174 13.2174V11.288C13.2174 9.91101 13.4991 8.82211 14.0747 8.11005C14.6503 7.398 15.5387 6.95652 17.0992 6.95652Z"
                class="fill-inherit"
            />
        </svg>
    }
</a>
